var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildhoodTrauma(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.39 29.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.99 23.29 15.19 24.71 17.4 23.29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.4,12.15c.51-.54.83-1.27.83-2.08,0-1.68-1.36-3.03-3.03-3.03s-3.03,1.36-3.03,3.03c0,.81.31,1.54.83,2.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.52,
    y1: 18.8,
    x2: 12.72,
    y2: 17.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.29,19.17l-.16-1.2c-.28-2.51-2.41-4.42-4.94-4.41h0c-2.53,0-4.65,1.9-4.93,4.41l-.16,1.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.67,
    y1: 17.34,
    x2: 17.87,
    y2: 18.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.51,7.97s0-.04,0-.06v-.08s0,0,0,0c0-.08,0-.15,0-.23,0-3.92-3.18-7.1-7.09-7.1-2.69,0-5.02,1.49-6.23,3.69-1.2-2.2-3.54-3.69-6.23-3.69C5.05.5,1.87,3.68,1.87,7.6c0,.07,0,.15,0,.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.87,22.53s.85-2.59,1.45-4.47c.1-.33.02-.69-.22-.93h0c-.43-.45-1.18-.35-1.48.19l-1.8,3.16-2.32,1.32c-.55.32-.96.84-1.12,1.46l-.72,2.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,15.69l1.99-5.2c.17-.45.64-.71,1.11-.61h0c.53.11.88.62.77,1.15l-2.18,10.89c-.16.78-.62,1.47-1.28,1.91l-2.58,1.72"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.01,28.68v-1.78c0-.39.32-.71.71-.71h3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.15,26.19h.98c.39,0,.71.32.71.71v1.78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.52,22.53s-.85-2.59-1.45-4.47c-.1-.33-.02-.69.22-.93h0c.43-.45,1.18-.35,1.48.19l1.8,3.16,2.32,1.32c.55.32.96.84,1.12,1.46l.72,2.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.39,15.69l-1.99-5.2c-.17-.45-.64-.71-1.11-.61h0c-.53.11-.88.62-.77,1.15l2.18,10.89c.16.78.62,1.47,1.28,1.91l2.58,1.72"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.38,28.68v-1.78c0-.39-.32-.71-.71-.71h-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.24,26.19h-.98c-.39,0-.71.32-.71.71v1.78"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildhoodTrauma);
export default __webpack_public_path__ + "static/media/childhood-trauma.f74d18b90f74eb7a5a45e8b0bcc01971.svg";
export { ForwardRef as ReactComponent };